import { useNotify, useRefresh, useRecordContext } from 'react-admin';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import PublishIcon from '@mui/icons-material/Publish';
import { request } from '../../services/request';
import { useOktaAuth } from '../../security/OktaContext';

const PREFIX = 'PublishButton';

const classes = {
  publishButton: `${PREFIX}-publishButton`,
  publishIcon: `${PREFIX}-publishIcon`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.publishButton}`]: {
    zIndex: 3000,
    marginLeft: theme.spacing(1),
  },

  [`& .${classes.publishIcon}`]: {
    fontSize: 20,
    marginRight: theme.spacing(0.5),
  },
}));

const apiUrl = `${import.meta.env.VITE_API_URL}/v1`;

const PublishButton = (props) => {
  const { oktaAuth } = useOktaAuth();
  const record = useRecordContext();
  const refresh = useRefresh();
  const notify = useNotify();

  const handleClick = async () => {
    const published = true;
    const updatedRecord = { ...record, published };
    const requestUrl = `${apiUrl}/queues/${record.id}`;
    const AuthorizationString = `Bearer ${oktaAuth.getAccessToken()}`;

    const requestOptions = {
      url: requestUrl,
      method: 'put',
      headers: {
        Accept: 'application/json',
        Authorization: AuthorizationString,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(updatedRecord),
    };

    try {
      await request(requestOptions);
      refresh();
      notify('Post published', { type: 'success' });
    } catch (err) {
      notify(err.errorData.message, { type: 'warning' });
    }
  };

  return (
    <StyledButton
      color="primary"
      size="small"
      onClick={handleClick}
      className={classes.publishButton}
    >
      <PublishIcon className={classes.publishIcon} />
      Publish
    </StyledButton>
  );
};

export default PublishButton;
